import React from "react";

import Svg, { Path } from "components/Svg";

const PowerOff = props => (
	<Svg
		width={15 * props.scale}
		height={12 * props.scale}
		viewBox="0 0 39.244 40.964"
	>
		<Path
			fill={props.fill || "black"}
			d="M0,22.075A18.246,18.246,0,0,1,7.586,7.51C8.7,6.7,10.822,6.4,11.632,7.409a3.36,3.36,0,0,1,.708,2.124c0,1.315-1.315,2.933-2.326,3.945a11.911,11.911,0,0,0-3.742,8.7A12.739,12.739,0,0,0,19.319,34.819,12.739,12.739,0,0,0,32.366,22.176a12.906,12.906,0,0,0-3.742-9.2c-.91-.91-2.225-2.63-2.023-3.945A2.571,2.571,0,0,1,27.815,7c1.113-.809,3.237-.2,4.248.607a18.451,18.451,0,0,1,7.181,14.565c0,10.519-9.406,18.712-19.926,18.712C8.9,40.888,0,32.7,0,22.075Z"
		/>
		<Path
			fill={props.fill || "black"}
			d="M19.635,24.174c-1.315,0-3.135-1.517-3.135-2.832V2.933A2.816,2.816,0,0,1,19.534,0a2.815,2.815,0,0,1,3.034,2.933V21.24a3.332,3.332,0,0,1-2.933,2.933Z"
		/>
	</Svg>
);

export default PowerOff;



// WEBPACK FOOTER //
// ./src/components/svgs/PowerOff/index.js